import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";


import Layout from "./components/Layout"; 
import SignIn from "./components/SignIn";
import ItemsTab from "./components/ItemsTab";    

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => sessionStorage.getItem("isAuthenticated") === "true");
  const [username, setUsername] = useState(() => sessionStorage.getItem("username") || "");

  const handleSignIn = (user) => {
    setIsAuthenticated(true);
    setUsername(user);
    sessionStorage.setItem("isAuthenticated", "true");
    sessionStorage.setItem("username", user);
  };

  return (
    <Router>
          <Routes>
            <Route path="/" element={<SignIn onSignIn={handleSignIn} />} />
            <Route
              path="/Home"
              element={
                isAuthenticated ? (
                  <Layout username={username}>
                    <ItemsTab />
                  </Layout>
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
          </Routes>
    </Router>
  );
};

export default App;
